import { ButtonGroup, ButtonGroupCircleX, ButtonOptionSecondary } from '@foyyay/flow-elements';
import { useSubmitHandler } from '@shared/hooks/useSubmitHandler';
import { withStopPropagation } from '@shared/lib/events';
import { getParentWindow } from '@shared/lib/getParentWindow';
import React, { useCallback, useEffect } from 'react';
import { ContinueButton } from '../../../components/StepActionButtons';
import {
  clearAddress,
  getCityAndState,
  isAddressValid,
  setAddress,
  setCurrentStep,
} from '../actions/stepPhysicalAddressActions';
import { ADDRESS_FIELDS } from '../constants';
import { selectAddress } from '../reducers/stepPhysicalAddressReducer';
import { HiddenAutofillFields } from './HiddenAutofillFields';

export const StepPhysicalAddressConfirm = (props) => {
  const { dispatch, useSelector, onComplete } = props;
  const address = useSelector(selectAddress);

  const handleClearAddress = useCallback(() => {
    dispatch(setCurrentStep('search'));
    dispatch(clearAddress());
  }, [dispatch]);

  const handleComplete = useCallback(() => {
    onComplete({ value: address });
  }, [address, onComplete]);

  const handleEditAddressField = useCallback((field) => dispatch(setCurrentStep(field)), [dispatch]);

  const handleChangeAddressField = useCallback(
    (value) => {
      dispatch(setAddress(value));
      setCurrentStep('confirm');
    },
    [dispatch]
  );

  const handleSubmit = useSubmitHandler(() => {});

  return (
    <form onSubmit={handleSubmit}>
      <AddressFields
        address={address}
        onComplete={handleComplete}
        onCancel={handleClearAddress}
        onEditAddressField={handleEditAddressField}
        onChangeAddressField={handleChangeAddressField}
        goBack={props.goBack}
      />
      <HiddenAutofillFields address={address} onChange={handleChangeAddressField} />
    </form>
  );
};

const AddressFields = (props) => {
  const { onChangeAddressField } = props;

  const handleCancelClick = withStopPropagation(() => {
    props.onCancel();
  });
  const handleContinueClick = withStopPropagation(props.onComplete);

  const isValid = isAddressValid(props.address);

  const setCityAndState = useCallback(
    async (address) => {
      const window = getParentWindow();
      const updates = await getCityAndState(address, window);
      onChangeAddressField(updates);
    },
    [onChangeAddressField]
  );

  // Use postal code to set city and state if either are missing
  useEffect(() => {
    if (props.address.postal_code && (!props.address.city || !props.address.state)) {
      setCityAndState(props.address);
    }
    // Fixme: There are issues here with running efects
  }, [props.address, setCityAndState]);

  // Set default country if missing
  useEffect(() => {
    if (!props.address.country) {
      onChangeAddressField({
        country: 'United States',
      });
    }
    // Fixme: There are issues here with running efects
  }, [props.address, onChangeAddressField]);

  return (
    <>
      <AddressFieldButtons address={props.address} onEditAddressField={props.onEditAddressField} />
      <ButtonGroup style={{ marginTop: '3rem' }}>
        <ButtonGroupCircleX onClick={handleCancelClick} />
        <ContinueButton disabled={!isValid} onClick={handleContinueClick} />
      </ButtonGroup>
    </>
  );
};

const ORDERED_ADDRESS_FIELDS = ['country', 'street_address', 'street_address_2', 'postal_code', 'city', 'state'];

const AddressFieldButtons = (props) => {
  return ORDERED_ADDRESS_FIELDS.map((key) => ADDRESS_FIELDS[key]).map((field) => {
    return (
      <ButtonOptionSecondary
        key={field.id}
        style={{ textAlign: 'left' }}
        badge={props.address[field.id] && field.label}
        onClick={() => props.onEditAddressField(field.id)}
      >
        {props.address[field.id] || <span style={{ opacity: 0.6 }}>+ Add {field.label}</span>}
      </ButtonOptionSecondary>
    );
  });
};
